import React, { useState, FormEvent, useEffect, useMemo } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Stack, Paper, Container } from '@mui/material'
import ProgressButton from '../../Utils/ProgressButton'
import { entityTextField } from '../../Utils/EntityField'
import { AppState } from '../../../reducers/index'
import { ProductBrandDetailState } from '../../../reducers/product/productBrandDetail'
import { upsertProductBrand } from '../../../actions/product/productBrandUpsert'
import ProductBrand from '../../../models/ProductBrand'
import { useTranslation } from 'react-i18next'
import { ISTableTitle } from '../../Utils/ISTable'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { fetchProductBrand } from '../../../actions/product/productBrandDetail'
import { BackButton } from '../../Utils/BackButton'
import Selector from '../../Selector'
import { isNil } from 'ramda'

interface Props {
  productBrand: ProductBrandDetailState
}

const empty: ProductBrand = {
  id: null,
  code: '',
  description: '',
  order: 0,
  ownerId: 0,
  ownerName: '',
  active: true
}

const ProductBrandUpsert: React.FC<Props> = ({ productBrand }) => {
  const [changed, setChanged] = useState<boolean>(false)
  const [productBrandInfo, setProductBrandInfo] = useState<ProductBrand>(productBrand.productBrand || empty)
  const { t } = useTranslation('product')
  const dispatch = useDispatch()
  const params = useParams<{ productBrandId: string }>()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (params.productBrandId) {
      dispatch(fetchProductBrand(params.productBrandId))
    }
  }, [dispatch, params.productBrandId])


  const change = (newProductBrandInfo: ProductBrand) => {
    setProductBrandInfo(newProductBrandInfo)
    setChanged(true)
  }

  const changeProductBrand = async (event: FormEvent) => {
    event.preventDefault()
    try {
      await dispatch(upsertProductBrand(productBrandInfo))
      setChanged(false)
      if (location.state)
        (location.state as any).update = !(location.state as any).update
      history.goBack()
    }
    catch {
    }
  }

  useEffect(() => {
    if (productBrand.productBrand) {
      setProductBrandInfo(params.productBrandId ? productBrand.productBrand : empty)
    }
  }, [productBrand.productBrand, params.productBrandId])

  const ProductBrandInfoField = useMemo(() => entityTextField(change), [])

  return (
    <Container>
      <Paper style={{ borderRadius: "10px", margin: "10px" }}>
        <ISTableTitle title={t('brands')} />
        <Paper style={{ padding: "10px" }}>
          <form onSubmit={changeProductBrand}>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductBrandInfoField
                style={{ width: "200px", marginRight: "10px" }}
                key="code"
                variant="outlined"
                label={t("code")}
                entity={productBrandInfo}
                attr="code"
                size="medium"
              />
              <ProductBrandInfoField
                //style={{ width: "100%"}}
                key="description"
                variant="outlined"
                label={t("description")}
                entity={productBrandInfo}
                attr="description"
                size="medium"
              />
            </Stack>
            <Stack display="flex" flexDirection="row" flexGrow={1} >
              <ProductBrandInfoField
                style={{ marginRight: "10px" }}
                key="order"
                variant="outlined"
                label={t("order")}
                entity={productBrandInfo}
                attr='order'
                size="medium"
              />
              <Selector
                key="active"
                label={t("active")}
                style={{ width: "100%" }}
                value={isNil(productBrandInfo.active) ? "" : Boolean(productBrandInfo.active)}
                textAdapter={(_value) => Boolean(_value) ? t("yes") : t("no")}
                menuItems={[true, false]}
              />
            </Stack>
            <Stack display="flex" flexDirection='row' justifyContent="space-between">
              <BackButton />
              <ProgressButton state={productBrand} disabled={!changed}>
                {t('save')}
              </ProgressButton>
            </Stack>
          </form>
        </Paper>
      </Paper>
    </Container>

  )
}

const mapStateToProps = (state: AppState) => ({
  productBrand: state.productBrandDetail
})

export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(ProductBrandUpsert)
